import React from 'react'
import AppMenuSection from './AppMenuSection'
import './style.css'

const resolveSettingLinks = (appId) => [
  { to: `/app/${appId}/info`, label: 'Display Information' },
  { to: `/app/${appId}/oauth`, label: 'Oauth & Scopes' },
  { to: `/app/${appId}/events`, label: 'Webhooks' },
  { to: `/app/${appId}/credentials`, label: 'App Credentials' }
]

const resolveActivateLinks = (appId) => [
  { to: `/app/${appId}/install`, label: 'Installing to Drift' }
]

const resolvePublishLinks = (appId) => [
  { to: `/app/${appId}/authorization`, label: 'Authorizing your App' },
  { to: `/app/${appId}/submit`, label: 'Submit to Directory' }
]

/*const resolveTriageLinks = (appId) => [
  { to: `/app/${appId}/monitor`, label: 'Monitor' }
]*/

const AppPageMenu = ({ appId }) => (
  <div className="app-page-menu">
    <AppMenuSection
      title="Settings"
      links={resolveSettingLinks(appId)}
      appId={appId}
    />

    <AppMenuSection
      title="Activate your App"
      links={resolveActivateLinks(appId)}
      appId={appId}
    />

    <AppMenuSection
      title="Make your App Public"
      links={resolvePublishLinks(appId)}
      appId={appId}
    />
    {/*<AppMenuSection
      title="Triage"
      links={resolveTriageLinks(appId)}
      appId={appId}
    />*/}
  </div>
)

export default AppPageMenu
